import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {environment} from '../environments/environment';
import {IOrder, Order} from '../models/order.model';

@Injectable({
  providedIn: 'root'
})

export class OrderService {

  constructor(private http: HttpClient) {}

  getOrder(): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get<any>(`${environment.url}/order`, {'headers': headers});
  }

  getOrderItem(): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get<any>(`${environment.url}/order_item/all`, {'headers': headers});
  }

  getOrderItem_v1(page: number, size: number, searchText: any): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get<any>(`${environment.url}/order_item/all-orderitems?page=${page}&size=${size}&searchText=${searchText}`, {'headers': headers});
  }

  getOrderItemById(id:any): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get<any>(`${environment.url}/order_item/`+id, {'headers': headers});
  }

  cancelDelivery(id: number): Observable<any> {
    return this.http.put<any>(`${environment.url}/order_item/cancelDelivery/`+id, null);
  }

  cancelDeliveryBackoffice(cancelOrderItem: any): Observable<any> {
    return this.http.post<any>(`${environment.url}/order_item/cancelDeliveryBackoffice`, cancelOrderItem, {});
  }

  query(page: number, size: number): Observable<any> {
    return this.http.get<any>(`${environment.url}/order` + (size ? '?page=' + page + '&size=' + size : ''));
  }

  getOrderBycurrentSearch(search: string, page: number, size: number) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get<any>(`${environment.url}/order` + ('/_search?search=name:' + search + '&page=' + page + '&size=' + size), {'headers': headers});
  }

  saveOrder(Order: IOrder) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.post<any>(`${environment.url}/order`, Order, {'headers': headers});
  }

  updateOrder(Order: IOrder) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.put<any>(`${environment.url}/order/` + Order.id, Order, {'headers': headers});
  }

  deliveredOrder(id: number) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.put<any>(`${environment.url}/order/delivered/` + id, null, {'headers': headers});
  }

  getIdOrder(idO: number) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get<any>(`${environment.url}/order/` + idO, {'headers': headers});
  }

  getIdOrderByOrderID(orderID: string) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get<any>(`${environment.url}/order/orderID/` + orderID, {'headers': headers});
  }

  deleteOrder(idO: number) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.delete(`${environment.url}/order/` + idO, {'headers': headers});
  }

  getCategoryNameByPostId(postId: number): Observable<any> {
    return this.http.get<any>(`${environment.url}/post/${postId}/category`);
  }
  getCategoryNameByPostIddd(postId: number): Observable<string> {
    return this.http.get<string>(`${environment.url}/post/${postId}/category`, { responseType: 'text' as 'json' });
  }

  allSellerOrderItems(page: number,
                      size: number,
                      isFilterByProductAndService: boolean,
                      isFilterByService: boolean,
                      isFilterByProduct: boolean,
                      startDate?: string,
                      endDate?: string,
                      orderItemSearchText?: string,
                      statusSearchText?: string): Observable<any> {
      let params = new HttpParams()
          .set('page', page.toString())
          .set('size', size.toString())
          .set('isFilterByProductAndService', isFilterByProductAndService.toString())
          .set('isFilterByService', isFilterByService.toString())
          .set('isFilterByProduct', isFilterByProduct.toString());

      if (startDate) {
          params = params.set('startDate', startDate);
      }
      if (endDate) {
          params = params.set('endDate', endDate);
      }
      if (orderItemSearchText) {
          params = params.set('orderItemSearchText', orderItemSearchText);
      }
      if (statusSearchText) {
          params = params.set('statusSearchText', statusSearchText);
      }

      return this.http.get(`${environment.url}/order_item/all-order-items`, { params });
  }

  findOrdersByUserId(userId: number, page: number, size: number): Observable<any> {
      let headers = new HttpHeaders();
      headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    
      // Construction de l'URL avec l'ID dans le chemin et les autres paramètres dans la requête
      let url = `${environment.url}/order_item/users-order-item/${userId}?page=${page}&size=${size}`;
      
      return this.http.get<any>(url, { headers });
  }


  getSellerOrderByOrderID(orderID: string, userId: number): Observable<Order> {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    // Construire l'URL avec les paramètres d'URL
    //const url = `${environment.url}/order/${orderID}/user/${userId}`;
    const url = `${environment.url}/order/seller-order/${orderID}/user/${userId}`;
    // Retourner l'appel HTTP GET
    return this.http.get<Order>(url, { headers });
  }

  findOrderItemsByOrderIDAndUserId(orderID: string, userId: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    const url = `${environment.url}/order/seller-orderitem/${orderID}/user/${userId}`;
    // Retourner l'appel HTTP GET
    return this.http.get<any>(url, { headers });
  }
}
